// Modules
import React from 'react';
import { isFunction } from './utils/genericValidation';

// Styles
import styles from './Button.module.scss';

const Button = (props) => {
  const {
    text,
    clickHandler,
    isDisabled,
    variant = 'blue',
    className,
    extraStyles = {},
    id,
    form,
    type,
  } = props;

  const handleClick = (e) => {
    if (typeof e.preventDefault === 'function') e.preventDefault();
    if (isDisabled) return;
    // @ts-ignore: clickHandler is only called if it exists
    if (isFunction(clickHandler)) clickHandler();
  };

  return (
    <button
      className={[styles.btn, styles[variant], className].join(' ')}
      style={extraStyles}
      onClick={handleClick}
      disabled={isDisabled}
      id={id}
      form={form}
      type={type}
    >
      {text}
    </button>
  );
};

export default Button;
